import { Amount, Icon, type IconName } from '@/components/foundations';

export type StatusHeroProps = {
  tone: 'ok' | 'warn' | 'err';
  label: string;
  icon?: IconName;
  /** Número = formatado em BRL (`Amount` grande); string = exibida como veio. */
  amount: number | string;
};

const ICON: Record<StatusHeroProps['tone'], IconName> = { ok: 'checkc', warn: 'clock', err: 'x' };

/** Status grande + valor do topo do painel de detalhes (`.status-lg` + `.amount`). */
export function StatusHero({ tone, label, icon = ICON[tone], amount }: StatusHeroProps) {
  return (
    <>
      <span className={`status-lg ${tone}`}><Icon name={icon} />{label}</span>
      {typeof amount === 'number' ? <Amount value={amount} size="lg" signed={false} /> : <div className="amount">{amount}</div>}
    </>
  );
}
